module.exports = (__webpack_public_path__ || '') + "static/images/apple-touch-icon-144x144-51e1a629052f81c6b9f1d3867489de66.png";